import { useState, useEffect } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { SectionOptionProps } from '../../../../ModularSectionOptions/types'
import { Module } from '../../types'

type PostOptionFormat = {
  [key: string]: string
}

export type ModulesDataFormat = {
  assets: AssetReference[] | null
  content: string
  sectionPostOptions: PostOptionFormat
  sectionOptions: SectionOptionProps[]
}

export default function useModuleSectionDataFormatter(
  module: Module
): ModulesDataFormat {
  const [assets, setAssets] = useState<AssetReference[] | null>(null)
  const [content, setContent] = useState<string>('')
  const [sectionPostOptions, setSectionPostOptions] =
    useState<PostOptionFormat>({})
  const [sectionOptions, setSectionOptions] = useState<SectionOptionProps[]>([])

  useEffect(() => {
    const newOptions: SectionOptionProps[] = []
    const newSectionPostOptions: PostOptionFormat = {}
    let newAssets: AssetReference[] | null = null
    let newContent = ''

    if (!module) return

    Object.keys(module).forEach((key) => {
      // snapshots pass in carousel assets as an array
      if (key.toLowerCase() === 'assets') {
        newAssets = (module[key] as AssetReference[]) || []
        newAssets = newAssets?.filter((asset) => asset.full_url && asset.id)
      } else if (key.toLowerCase().includes('asset')) {
        newAssets = newAssets || []
        if (module[key] !== null && module[key] !== '') {
          newAssets.push(module[key] as AssetReference)
        }
      } else if (key.toLowerCase().includes('content')) {
        newContent = (module[key] as string) || ''
      } else if (key.toLowerCase().includes('option')) {
        newOptions.push(module[key] as SectionOptionProps)
      } else {
        newSectionPostOptions[key] = module[key] as string
      }
    })

    setAssets(newAssets)
    setContent(newContent)
    setSectionPostOptions(newSectionPostOptions)
    setSectionOptions(newOptions)
  }, [module])

  return { assets, content, sectionPostOptions, sectionOptions }
}
